import { firstLetterToUppercase } from '../../../utils/formatString';
export var prepareAccountInfo = function prepareAccountInfo(_ref) {
  var publishedAnnouncementsCount = _ref.publishedAnnouncementsCount,
    lastActivityDate = _ref.lastActivityDate;
  var result = [];
  if (lastActivityDate) {
    result.push("\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0439 \u0440\u0430\u0437 \u0437\u0430\u0445\u043E\u0434\u0438\u043B\u0438 ".concat(lastActivityDate));
  }
  if (publishedAnnouncementsCount) {
    result.push(publishedAnnouncementsCount);
  }
  return firstLetterToUppercase(result.join(', '));
};